<amplify-authenticator variation="modal" [formFields]="formFields">
  <ng-template amplifySlot="header" class="login-header">
    <div class="login-header">
      <h1 class="align-self-center align-content-center text-center">Binview Login</h1>
    </div>
  </ng-template>

  <ng-template amplifySlot="confirm-sign-up-footer">
    <div class="amplify-flex amplify-alert amplify-alert--warning justify-content-center">
      <p class="amplify-heading--5">Please contact us to have your account enabled.</p>
    </div>
  </ng-template>

  <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
    <a href="#main-content" class="skip-link" (click)="focusMainContent($event)">Skip to main content</a>
    <app-navbar></app-navbar>
    <app-version-check-banner></app-version-check-banner>
    <main id="main-content" tabindex="-1" class="m-4">
      @if (stage$ | async; as s) {
        <div role="complementary" class="stage-text"><b>{{ s }}</b></div>
      }
      <router-outlet></router-outlet>
    </main>
  </ng-template>
</amplify-authenticator>
